import AOS from 'aos';

const $ = jQuery;
const $window = $(window);

// AOS animations Initialization.
const initAnimations = () => {
  $('.om-text-content h1, .h1').attr('data-aos', 'fade-up');

  AOS.init({
    startEvent: 'DOMContentLoaded',
    offset: 50,
    delay: 100,
    duration: 400, // values from 0 to 3000, with step 50ms
    easing: 'ease', // default easing for AOS animations
    once: true, // whether animation should happen only once - while scrolling down
    mirror: true, // whether elements should animate out while scrolling past them
    anchorPlacement: 'top-bottom',
  });

  // NVLG2220045-82 this lib is not reliable, intersection observer workaround necessary.
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (
        entry.isIntersecting &&
        !entry.target.classList.contains('aos-animate')
      ) {
        AOS.refresh();
      }
    });
  });
  document.querySelectorAll('[data-aos]').forEach((aosElem) => {
    observer.observe(aosElem);
  });
};

$window.on('load', () => initAnimations());
